export default __webpack_public_path__ + "static/media/ui_store_experience_banner_01.68521eff.png";